export default "/_next/static/5034d983fbb2c8d9809c7ed2bbcba607.png";